import { useState, useEffect } from 'react';
import axios from 'axios';

const VALIDATE_PATH = '/gateway/operator/login/attempt/validate';

/**
 * Validates a login attempt against the operator connector gateway.
 *
 * @param {string|null} gatewayBaseUrl – operator connector gateway base URL
 * @param {string|null} operator  – operator identifier
 * @param {string|null} attemptId – login attempt identifier
 * @returns {{ status: 'idle'|'loading'|'valid'|'invalid' }}
 */
export default function useValidateAttempt(gatewayBaseUrl, operator, attemptId) {
  const [status, setStatus] = useState('idle');

  useEffect(() => {
    if (!operator || !attemptId) return;

    if (!gatewayBaseUrl) {
      setStatus('invalid');
      return;
    }

    try {
      new URL(`${gatewayBaseUrl}${VALIDATE_PATH}`);
    } catch {
      setStatus('invalid');
      return;
    }

    const controller = new AbortController();
    setStatus('loading');

    axios
      .post(
        `${gatewayBaseUrl}${VALIDATE_PATH}`,
        { attemptId },
        {
          headers: {
            'X-Operator': operator,
            'X-Correlation-Id': crypto.randomUUID(),
          },
          signal: controller.signal,
        },
      )
      .then(({ data }) => {
        if (data.success && data.data?.valid) {
          setStatus('valid');
        } else {
          setStatus('invalid');
        }
      })
      .catch((err) => {
        if (!axios.isCancel(err)) setStatus('invalid');
      });

    return () => { controller.abort(); };
  }, [gatewayBaseUrl, operator, attemptId]);

  return { status };
}
